import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHttpUpdateProjectStatus } from '../../../hooks';
import { Button, RadioGroup } from '../../Common';
import { dispatch } from '../../../store';
import { ProjectStatus } from '@cyberlabrs/helpers';
import { selectCachedProjects, updateCachedProject } from '../../../store/slices/projects.slice';
import { ProjectDtoRelV2 } from '../../../commonTypes/project.types';

interface IChangeProjectStatus {
    close: () => void;
    projectId: string;
    currentStatus: ProjectStatus;
    onSuccess?: () => void;
}

const ChangeProjectStatus = ({ close, projectId, currentStatus, onSuccess }: IChangeProjectStatus) => {
    const projects = useSelector(selectCachedProjects);
    const oldProject = projects.find(p => p.id === projectId);
    const [selectedStatus, setSelectedStatus] = useState<ProjectStatus>(currentStatus);

    const { exec: updateProjectStatus } = useHttpUpdateProjectStatus();

    const projectStatusMenu = [
        { value: ProjectStatus.KICK_OFF, label: 'Kick Off' },
        { value: ProjectStatus.IN_PROGRESS, label: 'In Progress' },
        { value: ProjectStatus.ON_HOLD, label: 'On Hold' },
        { value: ProjectStatus.CANCELLED, label: 'Cancelled' },
        { value: ProjectStatus.COMPLETED, label: 'Completed' },
    ];

    const handleChangeStatus = () => {
        updateProjectStatus(projectId, selectedStatus, () => {
            const updatedProject = { ...oldProject, projectStatus: selectedStatus as ProjectStatus };
            dispatch(updateCachedProject(updatedProject as ProjectDtoRelV2));
            onSuccess?.();
        });
        close();
    };

    return (
        <div className="change-project-status">
            <div className="change-project-status__header">
                <h3 className="change-project-status__title">Change Project Status</h3>
                <p className="change-project-status__description">
                    This will immediately update the project's status and apply the change across all related views.
                </p>
            </div>
            <div className="edit-role__radio">
                <RadioGroup options={projectStatusMenu} value={selectedStatus} onChange={e => setSelectedStatus(e as ProjectStatus)} />
            </div>
            <div className="edit-role__buttons">
                <Button text={'Cancel'} variant="text" onClick={close} color="blue" />
                <Button text={'Save Changes'} onClick={handleChangeStatus} disabled={!selectedStatus} />
            </div>
        </div>
    );
};

export default ChangeProjectStatus;
